exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button[data-v-5ea786ec]{margin-top:35px}.handle[data-v-5ea786ec]{float:left}.close[data-v-5ea786ec],.handle[data-v-5ea786ec]{padding-top:8px;padding-bottom:8px}.close[data-v-5ea786ec]{float:right}input[data-v-5ea786ec]{display:inline-block;width:50%}.text[data-v-5ea786ec]{margin:20px}", ""]);

// exports
